import React from "react";
import "./Hero.css";

export default function NameRow({ name }) {
  return <h1 className="hero-name">{name}</h1>;
}
